import { render } from "./PlotLegendItemExpanded.vue?vue&type=template&id=5a2a984f"
import script from "./PlotLegendItemExpanded.vue?vue&type=script&lang=js"
export * from "./PlotLegendItemExpanded.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/OpenMCT/OpenMCT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__